import { Object3D } from 'three'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { awaitFor } from '../../utils/game'
import { GLTFActions } from '../animations/CharactersAnimations'

export const startWithAnimation = (anim: keyof GLTFActions) => async (obj: Object3D) => {
  await awaitFor({
    compare: () => {
      return useSceneStore.getState().getGameElementsAnimationActions().size > 0
    },
  })
  const animations = useSceneStore.getState().getGameElementsAnimationActions()
  const elementActions = animations.get(obj.uuid) as GLTFActions

  elementActions[anim].play()
}
